/* unplugin-vue-components disabled */import script from "./Reset.vue?vue&type=script&lang=ts&setup=true"
export * from "./Reset.vue?vue&type=script&lang=ts&setup=true"

import "./Reset.vue?vue&type=style&index=0&id=64a28cce&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64a28cce"]])

export default __exports__